$(document).ready(function () {
	$(document).on("click", "#sort-by-mobile .checkbox-control", function (t) {
		var e = $(this).find("input").val();
		$(this).addClass("active"),
			$(this).attr("aria-selected", "true"),
			$(this).find("input").checked,
			$('#sort-by-popover [value="' + e + '"]').trigger("click");
	}),
		$(document).on(
			"click",
			"#facets-drawer form .checkbox-control input",
			function (t) {
				jQuery("#facets-drawer .footer-facets button").trigger("click");
			}
		);

	$(document).on(
		"click",
		".collection-toolbar__button-list .collection-toolbar__button",
		function (t) {
			$("html").addClass("filter");
		}
	);

	if ($(".collection-toolbar").length > 0) {
		// The element with class 'collection-toolbar' exists
		window.onscroll = function () {
			stickyToolbar();
		};

		function stickyToolbar() {
			var toolbar = $(".collection-toolbar");
			var offsetTop = toolbar.offset().top;
			// console.log("Offset Top:", offsetTop);
			// console.log(window.pageYOffset);
			if (window.pageYOffset > offsetTop) {
				toolbar.addClass("sticky");
			} else {
				toolbar.removeClass("sticky");
			}
		}
		// Select the HTML element
		const htmlElement = document.querySelector("html");

		// Create a new MutationObserver
		const observer = new MutationObserver((mutationsList, observer) => {
			// Check each mutation in the list
			for (let mutation of mutationsList) {
				// If the class "lock" was removed
				if (
					mutation.type === "attributes" &&
					mutation.attributeName === "class" &&
					!htmlElement.classList.contains("lock")
				) {
					$("html").removeClass("filter");
				}
			}
		});

		// Start observing changes to attributes of the HTML element
		observer.observe(htmlElement, { attributes: true });
	}
}),
	$(document).on("click", ".accordion-list details", function (t) {
		$(".accordion-list details")
			.not(this)
			.attr("aria-expanded", "false")
			.removeAttr("open");
		let e = "true" === $(this).attr("aria-expanded");
		$(this).attr("aria-expanded", e ? "false" : "true"),
			e ? $(this).removeAttr("open") : $(this).attr("open", "");
	}),
	$(document).on("click", function (t) {
		let e = $(t.target);
		e.closest(".accordion-list details summary").length ||
			$(".accordion-list details").each(function () {
				$(this).is(e) || $(this).attr("aria-expanded", "false");
			});
	}),
	document.addEventListener("product:added", function (t) {
		document.dispatchEvent(new Event("cart:refresh")),
			setTimeout(function () {
				var t = document.querySelector('[aria-controls="cart-drawer"]');
				if (t) {
					var e = new MouseEvent("click", {
						bubbles: !0,
						cancelable: !0,
						view: window,
					});
					t.dispatchEvent(e);
				}
			}, "500");
	});

// Function to toggle aria-expanded and open attribute
function toggleAttributes(event) {
	const element = event.currentTarget;
	const isExpanded = element.getAttribute("aria-expanded") === "true";

	if (isExpanded) {
		element.setAttribute("aria-expanded", "false");
		element.removeAttribute("open");
	} else {
		element.setAttribute("aria-expanded", "true");
		element.setAttribute("open", "");
	}
}

// Wait for the DOM to load
document.addEventListener("DOMContentLoaded", (event) => {
	// Get all elements with the specified attribute
	const elements = document.querySelectorAll(
		'[is="dropdown-menu-disclosure"]'
	);

	// Loop through each element and add a click event listener
	elements.forEach((element) => {
		element.addEventListener("click", toggleAttributes);
	});
});

function checkScroll() {
	if (window.scrollY >= 300) {
		document.body.classList.add("sticky-header");
	} else {
		document.body.classList.remove("sticky-header");
	}
}

// Add an event listener for the scroll event
window.addEventListener("scroll", checkScroll);
